export default __webpack_public_path__ + "static/media/bubble-coming-soon.c2f72c7e.svg";